module.exports = __webpack_public_path__ + "static/media/sql_server_logo.5c92c69e.png";